import type { TError, TPromoBannerForEntity } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../../axios';
import { ENTITY } from '../entity';

export const getPromoBannerForEntityQueryKey = (entityId: string) => [ENTITY, 'promo-banners', 'for-entity', entityId];

/**
 * The public promo banner placed on an entity (with its position) — used by
 * member-facing pages to render the banner. Null when none.
 */
export const useGetPromoBannerForEntity = (entityId: string | undefined) => {
  return useQuery<TPromoBannerForEntity | null, TError>({
    queryKey: getPromoBannerForEntityQueryKey(entityId ?? ''),
    queryFn: async () => {
      const res = await axios.get<TPromoBannerForEntity | null>('/community-hub/promo-banners/for-entity', {
        params: { entityId },
      });
      return res.data;
    },
    enabled: !!entityId,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
